import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Link } from 'react-router';
import { Comatose, DateFormat, TimeFormat } from 'components/helpers/utils';
import TransactionZapCashIcon from 'components/icons/TransactionZapCashIcon';
import TransactionZapCardIcon from 'components/icons/TransactionZapCardIcon';
import TransactionCouponIcon from 'components/icons/TransactionCouponIcon';

import '../styles/transaction-list.less';

export default class TransactionList extends React.Component {
  static propTypes = {
    transactions: PropTypes.shape({
      edges: PropTypes.array,
    }),
    seeMore: PropTypes.bool,
  };

  renderPointsAllotment(a, hasBranch, type) {
    let earn, redeem, icon;

    if (a.currency.rawId === '1') {
      icon = (
        <div className='icon-container'>
          <TransactionZapCashIcon />
        </div>
      );
    } else {
      icon = (
        <div className='icon-container'>
          <TransactionZapCardIcon />
        </div>
      );
    }

    if (a.earnAmount) {
      let action = !hasBranch ? 'Added' : 'Earned';
      let earnClass = classNames('earned', { zap: !hasBranch });

      earn = (
        <div className={earnClass}>
          {icon} {Comatose(a.earnAmount)} {a.currency.name} {action}
        </div>
      );
    }

    if (a.redeemAmount) {
      let action, redeemClass;
      if (type === 'ExpiredPoints' && a.currency.rawId !== '1') {
        action = 'Expired';
        redeemClass = classNames('expired', { zap: !hasBranch });
      } else {
        action = !hasBranch ? 'Removed' : 'Redeemed';
        redeemClass = classNames('redeemed', { zap: !hasBranch });
      }
      redeem = (
        <div className={redeemClass}>
          {icon} {Comatose(a.redeemAmount)} {a.currency.name} {action}
        </div>
      );
    }

    let key = a.currency.rawId.concat('-', a.earnAmount, '-', a.redeemAmount);

    return (
      <div key={key} className='allotment'>
        {earn}
        {redeem}
      </div>
    );
  }

  renderCouponAllotment(a) {
    let earn, redeem;

    let icon = (
      <div className='icon-container'>
        <TransactionCouponIcon />
      </div>
    );

    if (a.earn) {
      earn = (
        <div className='earned'>
          {icon} Coupon Earned - {a.promotionName}
        </div>
      );
    }

    if (a.redeem) {
      redeem = (
        <div className='redeemed'>
          {icon} Coupon Redeemed - {a.promotionName}
        </div>
      );
    }

    let key = a.couponId;

    return (
      <div key={key} className='allotment'>
        {earn}
        {redeem}
      </div>
    );
  }

  renderTransactionItem(i) {
    let merchantName = i.node.merchant ? i.node.merchant.name : 'ZAP';
    let branchName = i.node.branch ? '(' + i.node.branch.name + ')' : '';
    let hasBranch = branchName !== '';
    let hasAmount = i.node.pointsAllotments.length > 0;
    let amountClass = classNames('amount', { 'currency-amount': hasAmount });
    let amount = hasAmount ? Comatose(i.node.amount) : '--';

    return (
      <div key={i.node.id} className={'item ' + i.node.status.toLowerCase()}>
        <div className='txnid'>
          {i.node.rawId}
          <div className={i.node.status.toLowerCase()}>
            <span className='bullet' />
            {i.node.status.toLowerCase()}
          </div>
        </div>
        <div className='date'>
          {DateFormat(i.node.transactedAt)}
          <br />
          {TimeFormat(i.node.transactedAt)}
        </div>
        <div className='merchant'>
          {merchantName} {branchName}
        </div>
        <div className={amountClass}>{amount}</div>
        <div className='desc'>
          {i.node.pointsAllotments.map((a) =>
            this.renderPointsAllotment(a, hasBranch, i.node.type)
          )}
          {i.node.couponAllotments.map((a) => this.renderCouponAllotment(a))}
        </div>
      </div>
    );
  }

  render() {
    let seeMoreView;

    if (this.props.seeMore) {
      seeMoreView = (
        <div className='see-more'>
          <Link to='/transactions'>Click here to see more</Link>
        </div>
      );
    }

    if (this.props.transactions.edges.length > 0) {
      return (
        <div className='transaction-list'>
          <div className='header'>
            <div className='txnid'>Transaction ID</div>
            <div className='date'>Date/Time</div>
            <div className='merchant'>Merchant & Branch</div>
            <div className='amount'>Amount</div>
            <div className='desc'>Description</div>
          </div>
          <div>
            <div className='items'>
              {this.props.transactions.edges.map((i) =>
                this.renderTransactionItem(i)
              )}
            </div>
            {seeMoreView}
          </div>
        </div>
      );
    }
    return (
      <div className='no-transactions'>
        <span>No transactions.</span>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./js/components/widgets/TransactionList.js